"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactCreateRef = _interopRequireDefault(require("react-create-ref"));
var _requestAnimationFrameTimeout = require("request-animation-frame-timeout");
var _OnFocusOut = _interopRequireDefault(require("./OnFocusOut"));
var _OnTapOutside = _interopRequireDefault(require("./OnTapOutside"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // For some weird reason, in Chrome, `setTimeout()` would lag up to a second (or more) behind.
// Turns out, Chrome developers have deprecated `setTimeout()` API entirely without asking anyone.
// Replacing `setTimeout()` with `requestAnimationFrame()` can work around that Chrome bug.
// https://github.com/bvaughn/react-virtualized/issues/722
/**
 * `<OnFocusOutOrTapOutside/>` sets `onBlur` on the child element.
 * Calls `onFocusOut` on focus out or tap outside.
 */
var OnFocusOutOrTapOutside = /*#__PURE__*/function (_React$Component) {
  _inherits(OnFocusOutOrTapOutside, _React$Component);
  var _super = _createSuper(OnFocusOutOrTapOutside);
  function OnFocusOutOrTapOutside() {
    var _this;
    _classCallCheck(this, OnFocusOutOrTapOutside);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "onFocusOutRef", (0, _reactCreateRef["default"])());
    _defineProperty(_assertThisInitialized(_this), "onTapOutsideRef", (0, _reactCreateRef["default"])());
    // These're called from outside in `<Expandable/>`.
    _defineProperty(_assertThisInitialized(_this), "stopListeningToTouches", function () {
      return _this.onTapOutsideRef.current.stopListeningToTouches();
    });
    _defineProperty(_assertThisInitialized(_this), "listenToTouches", function () {
      return _this.onTapOutsideRef.current.listenToTouches();
    });
    _defineProperty(_assertThisInitialized(_this), "onBlur", function (event) {
      if (_this.onFocusOutRef.current) {
        _this.onFocusOutRef.current.onBlur(event);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onFocusOut", function (event) {
      // `onFocusOut` is triggered right after `onTapOutside`.
      // This workaround prevents duplicate `onFocusOut` call.
      if (_this.onTapOutsideTimer) {
        (0, _requestAnimationFrameTimeout.clearTimeout)(_this.onTapOutsideTimer);
        _this.onTapOutsideTimer = undefined;
      }
      var onFocusOut = _this.props.onFocusOut;
      onFocusOut(event);
    });
    _defineProperty(_assertThisInitialized(_this), "onTapOutside", function (event) {
      var onTapOutsideDelay = _this.props.onTapOutsideDelay;
      (0, _requestAnimationFrameTimeout.clearTimeout)(_this.onTapOutsideTimer);
      _this.onTapOutsideTimer = (0, _requestAnimationFrameTimeout.setTimeout)(function () {
        // `onFocusOut` is triggered right after `onTapOutside`.
        // This workaround prevents duplicate `onFocusOut` call.
        if (_this.onTapOutsideTimer) {
          _this.onTapOutsideTimer = undefined;
          var onFocusOut = _this.props.onFocusOut;
          onFocusOut(event);
        }
      }, onTapOutsideDelay);
    });
    return _this;
  }
  _createClass(OnFocusOutOrTapOutside, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var listenToTouches = this.props.listenToTouches;
      if (listenToTouches) {
        this.listenToTouches();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _requestAnimationFrameTimeout.clearTimeout)(this.onTapOutsideTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        getTogglerNode = _this$props.getTogglerNode,
        getContainerNode = _this$props.getContainerNode;
      var children = this.props.children;
      children = /*#__PURE__*/_react["default"].cloneElement(children, {
        onBlur: this.onBlur
      });
      children = /*#__PURE__*/_react["default"].createElement(_OnFocusOut["default"], {
        ref: this.onFocusOutRef,
        getContainerNode: getContainerNode,
        getTogglerNode: getTogglerNode,
        onFocusOut: this.onFocusOut
      }, children);
      return /*#__PURE__*/_react["default"].createElement(_OnTapOutside["default"], {
        ref: this.onTapOutsideRef,
        getContainerNode: getContainerNode,
        getTogglerNode: getTogglerNode,
        onTapOutside: this.onTapOutside
      }, children);
    }
  }]);
  return OnFocusOutOrTapOutside;
}(_react["default"].Component);
exports["default"] = OnFocusOutOrTapOutside;
OnFocusOutOrTapOutside.propTypes = {
  getContainerNode: _propTypes["default"].func.isRequired,
  getTogglerNode: _propTypes["default"].func,
  onFocusOut: _propTypes["default"].func.isRequired,
  onTapOutsideDelay: _propTypes["default"].number,
  listenToTouches: _propTypes["default"].bool,
  children: _propTypes["default"].node.isRequired
};
OnFocusOutOrTapOutside.defaultProps = {
  // `onFocusOut` is triggered right after `onTapOutside`.
  // This workaround prevents duplicate `onFocusOut` call.
  onTapOutsideDelay: 30,
  listenToTouches: true
};
//# sourceMappingURL=OnFocusOutOrTapOutside.js.map